import { render, staticRenderFns } from "./ExhibitorEditTabSocial.vue?vue&type=template&id=7d16d5e6&"
import script from "./ExhibitorEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./ExhibitorEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports